import type { HomeSettings } from '~/features/home/utils/homeSettings';

let queue: Promise<unknown> = Promise.resolve();
let pendingWrites = 0;
let writtenScope: HomeSettings['scope'] | undefined;

// A write queued behind another was handed settings from before that write
// landed, so within one burst the scope the previous write stored wins. It
// is dropped once the queue drains, when callers' settings are fresh again.
export function serializeScopeWrite(
  run: (
    currentSettings: (settings: HomeSettings) => HomeSettings,
  ) => Promise<{ settings: HomeSettings }>,
) {
  const currentSettings = (settings: HomeSettings) =>
    writtenScope === undefined
      ? settings
      : { ...settings, scope: writtenScope };
  const guarded = async () => {
    const result = await run(currentSettings);
    writtenScope = result.settings.scope;
    return result;
  };
  pendingWrites += 1;
  const next = queue.then(guarded, guarded).finally(() => {
    pendingWrites -= 1;
    if (pendingWrites === 0) {
      writtenScope = undefined;
    }
  });
  queue = next.catch(() => {});
  return next;
}

export function resetScopeWriteQueueForTests() {
  queue = Promise.resolve();
  pendingWrites = 0;
  writtenScope = undefined;
}
